module.exports = __webpack_public_path__ + "img/235.4c28ebf4.jpg";